import { brandLabel } from './brandNames';
// Shared vocabulary for the fabric hierarchy + stock badges.
// Coulisse uses Brand → Type → Collection → Color; other brands (DW) use Brand → Collection → Color.

export const tierLabels = (brandName) => {
  const coulisse = /coulisse/i.test(brandName || '');
  return coulisse
    ? { tier2: 'Type', tier2Plural: 'Types', tier3: 'Collection', tier3Plural: 'Collections' }
    : { tier2: 'Collection', tier2Plural: 'Collections', tier3: 'Material', tier3Plural: 'Materials' };
};

// Canonical identifier shown everywhere: Brand › Type › Collection › Color (CODE)
export const fabricIdentifier = (c) =>
  [brandLabel(c.brand_name), c.collection_name, c.material_name, c.name || c.color_name].filter(Boolean).join(' › ') + (c.code ? ` (${c.code})` : '');

// Stock status is shown as a small colored dot; the label only appears on hover.
export const STOCK_OPTIONS = [
  { value: 'in_stock', label: 'Stock available', className: 'bg-emerald-600 text-white', dot: 'bg-emerald-500', ring: 'ring-emerald-200' },
  { value: 'limited', label: 'Limited stock available', className: 'bg-amber-500 text-white', dot: 'bg-orange-500', ring: 'ring-orange-200' },
  { value: 'not_in_stock', label: 'No stock available', className: 'bg-red-600 text-white', dot: 'bg-red-500', ring: 'ring-red-200' },
];

// "Discontinued" is an independent flag (a fabric can be discontinued AND still have limited stock).
export const DISCONTINUED = { value: 'discontinued', label: 'Discontinued item', className: 'bg-red-700 text-white', dot: 'bg-red-600' };

export const stockBadge = (status) => STOCK_OPTIONS.find((o) => o.value === status) || null;

// Hidden by the public "In stock only" filter.
export const isUnavailable = (e) => e?.stock_status === 'not_in_stock' || !!e?.discontinued;

export const stockSummary = (e) =>
  [stockBadge(e?.stock_status)?.label, e?.discontinued ? DISCONTINUED.label : null].filter(Boolean).join(' · ');
